import { render, staticRenderFns } from "./Alergias.vue?vue&type=template&id=01b8ac76&scoped=true"
import script from "./Alergias.vue?vue&type=script&lang=js"
export * from "./Alergias.vue?vue&type=script&lang=js"
import style0 from "./Alergias.vue?vue&type=style&index=0&id=01b8ac76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b8ac76",
  null
  
)

export default component.exports